import { render, staticRenderFns } from "./mgcPop.vue?vue&type=template&id=0ba044c9&scoped=true"
import script from "./mgcPop.vue?vue&type=script&lang=js"
export * from "./mgcPop.vue?vue&type=script&lang=js"
import style0 from "./mgcPop.vue?vue&type=style&index=0&id=0ba044c9&prod&lang=scss&scoped=true"
import style1 from "./mgcPop.vue?vue&type=style&index=1&id=0ba044c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba044c9",
  null
  
)

export default component.exports